import { PostJsonResponse, usePostJson } from "../api-client/usePostJson";

export const updatePartPackageByPartId = (
  dealerId: string
): PostJsonResponse<PackageUpdateOutput, PackageUpdateInput> =>
  usePostJson<PackageUpdateOutput, PackageUpdateInput>(
    `/retailSiteWebService/parts/partPackage/updatePartPackageByPartId.php?dealerId=${dealerId}`
  );

export type DealerPackagePart = {
  partId: string;
  partType: string;
  quantity: number;
};

type CustomPart = {
  customName: string;
  customNameFr: string;
  customPartNumber: string;
  customPrice?: string;
  customTypeName: string;
  customTypeNameFr: string;
  quantity: number;
};

export type DealerPackageMappedId = {
  vehicleModelId: string;
  vehicleSubmodelId: string;
  vehicleYearId: string;
};

export type PackageUpdateInput = {
  customParts: CustomPart[];
  mappedIds: DealerPackageMappedId[];
  packageDescription: string;
  packageDescriptionFr: string;
  packageExpireDate: string;
  packageId?: string;
  packageImageFileContents?: string;
  packageImageUrl: string;
  packageName: string;
  packagePartNumber: string;
  packagePrice: number;
  packageReleaseDate: string;
  parts: DealerPackagePart[];
};

type PackageUpdateOutput = unknown;
